/**
 * Every language Adea is built in. Only the live ones can be picked by a person or resolved from a
 * browser; the others exist in the same structure and stay off until a native reader has reviewed them
 * (PLAN §18 A, §6.10).
 */
export const LOCALES = ["en", "da", "sv", "de", "fr", "es"] as const;
export type Locale = (typeof LOCALES)[number];

export const LIVE_LOCALES = ["en", "da"] as const satisfies readonly Locale[];
export type LiveLocale = (typeof LIVE_LOCALES)[number];

export const DEFAULT_LOCALE: LiveLocale = "en";

/** The Intl tag used for numbers, dates and plurals. English follows British conventions ("10 Sept 2026"). */
export const INTL_TAGS: Record<Locale, string> = {
  en: "en-GB",
  da: "da-DK",
  sv: "sv-SE",
  de: "de-DE",
  fr: "fr-FR",
  es: "es-ES",
};

/** The language's own name, for the language picker. */
export const LOCALE_NAMES: Record<Locale, string> = {
  en: "English",
  da: "Dansk",
  sv: "Svenska",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
};

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}

export function isLiveLocale(value: unknown): value is LiveLocale {
  return typeof value === "string" && (LIVE_LOCALES as readonly string[]).includes(value);
}

export function intlTag(locale: Locale): string {
  return INTL_TAGS[locale];
}
